export const data9_8_2_default = [
   {
      name: "餐饮用纸",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "客房用纸",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "餐饮洗涤剂",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "餐饮催干剂",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "客房全能水",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "客房高泡地毯水",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "洗衣房主洗液",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "洗衣房碱液",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "洗衣房柔顺剂",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "拖鞋",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "洗发水",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "护发素",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "沐浴露",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "润肤露",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }
];


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-8/9-8-4/data.js